// Time-of-day greeting from the viewer's own clock: 5:00-11:59 morning, 12:00-16:59 afternoon, 17:00-4:59 evening.
export function greetingWord(hour) {
  const h = Number.isFinite(hour) ? hour : 18;
  if (h >= 5 && h < 12) return 'Good morning';
  if (h >= 12 && h < 17) return 'Good afternoon';
  return 'Good evening';
}

// "Good evening, Ayaz." or, with no name, "Good evening." Pass a capitalised first name.
export function greetingText(hour, firstName) {
  const name = String(firstName == null ? '' : firstName).trim();
  return name ? `${greetingWord(hour)}, ${name}.` : `${greetingWord(hour)}.`;
}
